import React from 'react';
import Chip from '@mui/material/Chip';

const PAYMENT = {
  pending: { label: 'Pendente', color: 'warning' },
  paid: { label: 'Pago', color: 'success' },
  cancelled: { label: 'Cancelado', color: 'default' },
  refunded: { label: 'Estornado', color: 'info' },
};

export const PaymentStatusChip = ({ status, size = 'small' }) => {
  const cfg = PAYMENT[status] || { label: status, color: 'default' };
  return <Chip size={size} label={cfg.label} color={cfg.color} variant={status === 'paid' ? 'filled' : 'outlined'} />;
};

export default PaymentStatusChip;
